<template>
  <div v-loading="isBusy">
    <el-tabs value="common">
      <el-tab-pane label="Common" name="common">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          element-loading-spinner="el-icon-loading"
          label-width="170px"
        >
          <el-form-item label="Brand" prop="brand_id">
            <el-select v-model="form.brand_id" clearable>
              <el-option
                v-for="{value, label} in brandOptions"
                :key="value"
                :value="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Representative" prop="representative_id">
            <el-select v-model="form.representative_id" clearable>
              <el-option
                v-for="{value, label} in representativeOptions"
                :key="value"
                :value="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Provider" prop="provider_id">
            <el-select v-model="form.provider_id" clearable>
              <el-option
                v-for="{value, label} in providerOptions"
                :key="value"
                :value="value"
                :label="label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Title" prop="title">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="Address" prop="address">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="Signature" prop="signature">
            <el-input v-model="form.signature"></el-input>
          </el-form-item>
        </el-form>
        <button class="btn btn-purple px-4" @click="store">Store</button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BaseForm from '../form';

export default {
  extends: BaseForm,

  props: {
    brandOptions: Array,
    representativeOptions: Array,
    providerOptions: Array,
  },

  data() {
    const form = {
      brand_id: null,
      representative_id: null,
      provider_id: null,
      title: null,
      address: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    }
  },

  computed: {
    //
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },
  },
}
</script>
